module.exports = __webpack_public_path__ + "icomoon.ddd818f6c1d4cc8bcdf8";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.ttf?mkks98
// module id = ../../../../../src/assets/vendors/by_hands/font-icomoon/fonts/icomoon.ttf?mkks98
// module chunks = styles